<h3 mat-dialog-title>Log in</h3>

<mat-dialog-content>
  <form [formGroup]="userForm" fxLayout="column" (keyup.enter)="onLogin()">
    <mat-form-field appearance="outline" style="margin-top: 10px">
      <mat-label>{{'CORE.LOGIN.USERNAME' | translate }} <span style="color:#ef5350; font-weight: bold">*</span></mat-label>
      <input matInput [(ngModel)]="username" formControlName="username"/>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{'CORE.LOGIN.PASSWORD' | translate }} <span style="color:#ef5350; font-weight: bold">*</span></mat-label>
      <input matInput [(ngModel)]="password" formControlName="password" type="password"/>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions fxLayout="column" fxLayoutAlign="center center">
  <button mat-raised-button color="primary" type="submit" (click)="onLogin()" [disabled]="loading">{{ 'CORE.LOGIN.SIGN_IN' | translate }}</button>
  <mat-spinner *ngIf="loading" class="not-so-close-from-button login-spinner" [diameter]="30"></mat-spinner>
  <div *ngIf="(errorMessage !== null || errorMessage !== '')" class="errorMessage not-so-close-from-button">
    {{errorMessage}} </div>
</mat-dialog-actions>

